import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import EnvelopeRecipients from "./Recipients";
import {
  envelopeFinish,
  removeEnvelopeSignDocument
} from "../../../../services/CommonService";
import { toast } from "react-toastify";
import Utils from "../../../../utils";
import SearchRecipient from "./SearchRecipient";
import {
  DATE_FORMAT_LIST,
  NAME_CONVENTION,
  OVERDUE_REMINDER,
  PASSWORD_LIST,
  SEND_REMINDER, SMS_SENDER_LIST, PER_SMS_AMOUNT,
  SYNC_STATUS
} from "../../../../configs/AppConfig";

import MakeFillablePopup from "./MakeFillablePopup";
import { CustomSelect, CustomDatePicker } from "../../../../components";

// import { Lang } from "../../../../lang";
// import DatePicker from "react-datepicker";
import { default as ReactSelect } from "react-select";
import { components } from "react-select";
import "../../../../assets/css/sleeve.css";

function EnvelopeStep4(props) {
  const navigate = useNavigate();
  const [senderList, setSenderList] = useState([]);
  const [sendEnvelopeBy, setSendEnvelopeBy] = useState(1);
  const [smsType, setSmsType] = useState(1);
  const [smsAmount, setSmsAmount] = useState(0);
  const [envelopeSenderId, setEnvelopeSenderId] = useState(0);
  const [pastDate, setPastDate] = useState(new Date());
  const [envelopeName, setEnvelopeName] = useState('');
  const [envelopeDate, setEnvelopeDate] = useState('');
  const [clientMessage, setClientMessage] = useState('');
  const [subject, setSubject] = useState('');
  const [emailText, setEmailText] = useState('');
  const [isInvited, setIsInvited] = useState(0);
  const [isEditRecipient, setIsEditRecipient] = useState(false);
  const [isEditDocument, setIsEditDocument] = useState(false);
  const [isEditRequestForm, setIsEditRequestForm] = useState(false);
  const [isEditSignDocumentForm, setIsEditSignDocumentForm] = useState(false);
  const [isAddTemplate, setAddTemplate] = useState(false);

  const [nameConvention, setNameConvention] = useState(1);
  const [syncStatusList, setSyncStatusList] = useState(SYNC_STATUS);
  const [cloudSync, setCloudSync] = useState([]);
  const [sendReminder, setSendReminder] = useState(0);
  const [overdueReminder, setOverdueReminder] = useState(0);
  const [isPassword, setIsPassword] = useState(0);
  const [password, setPassword] = useState('');
  const [referenceId, setReferenceId] = useState('');
  const [nameConventionText, setNameConventionText] = useState('');
  const [cloudSyncText, setCloudSyncText] = useState([]);
  const [sendReminderText, setSendReminderText] = useState('');
  const [overdueReminderText, setOverdueReminderText] = useState('');
  const [passwordText, setPasswordText] = useState('');
  const [referenceText, setReferenceText] = useState('');

  const [signatureDocumentData, setSignatureDocumentData] = useState(null);
  const [directMakeFillableOpen, setDirectMakeFillableOpen] = useState(false);


  const btnSignDocumentPopup = useRef(null);
  const addTemplateRef = useRef(null);
  const clsAddTemplateRef = useRef(null);
  const openCheckSMSCreditRef = useRef(null);
  const openCloudStorageRef = useRef(null);
  const dueDateRef = useRef(null);

  const [makeFillable, setMakeFillable] = useState(false);

  const [isAdditionalSetting, setIsAdditionalSetting] = useState(false);

  const [deleteEnvelope, setDeleteEnvelope] = useState({ id: 0, name: '' });

  const [recipientData, setRecipientData] = useState({
    id: 0,
    first_name: "",
    last_name: "",
    email: "",
    mobile: "",
    country_id: 227,
    company_name: "",
    address_1: "",
    address_2: "",
    city: "",
    state: "",
    address_country_id: "",
    zipcode: "",
  });


  let errorsObj = {
    sender_id: "",
    envelope_name: "",
    envelope_date: "",
    client_message: "",
    recipient: "",
    subject: "",
    email_text: "",
    documents: "",
    fill_forms: "",
    sign_documents: "",
    password: ''
  };
  const [errors, setErrors] = useState(errorsObj);

  const [fromTemplate, setFromTemplate] = useState(1);
  const [isUseFromTemplate, setIsUseFromTemplate] = useState(false);

  const buttonRef = useRef(null);

  useEffect(() => {
    setPastDate(Utils.pastDate());

    if (props?.senderList.length > 0) {
      setSenderList(props.senderList);
    }
    setSendEnvelopeBy((props.formObj.send_envelope_by) ? parseInt(props.formObj.send_envelope_by) : '');
    setEnvelopeSenderId((props.formObj.sender_id) ? props.formObj.sender_id : '');
    setEnvelopeName(Utils.getCleanEnvelopeName(props.formObj.envelope_name, props.formObj?.is_negotiation));
    setEnvelopeDate((props.formObj.envelope_date) ? props.formObj.envelope_date : '');
    setClientMessage((props.formObj.client_message) ? props.formObj.client_message : '');
    setSubject((props.formObj.subject) ? props.formObj.subject : '');
    setEmailText((props.formObj.email_text) ? props.formObj.email_text : '');

    setSmsType((props.formObj.sms_type) ? parseInt(props.formObj.sms_type) : 1);
    let smsIndex = SMS_SENDER_LIST.findIndex(x => x.id === parseInt(props.formObj.sms_type));
    if (smsIndex > -1) {
      setSmsAmount(SMS_SENDER_LIST[smsIndex]['amount'] * props.formObj.recipient_List.length);
    }

    let ncId = (props.formObj.name_convention) ? props.formObj.name_convention : 1;
    let ncIndex = NAME_CONVENTION.findIndex(x => parseInt(x.id) === parseInt(ncId));
    if (ncIndex > -1) {
      setNameConventionText(NAME_CONVENTION[ncIndex]['value']);
    }
    setNameConvention(parseInt(ncId));
    let csId = (props.formObj.cloud_sync) ? props.formObj.cloud_sync : 0;
    const array = String(csId).split(",").map(Number);

    if (props.formObj.sync_status_list && props.formObj.sync_status_list.length > 0) {
      setSyncStatusList(props.formObj.sync_status_list);
      const csIndex = array.map((value) =>
        props.formObj.sync_status_list.find(x => parseInt(x.id) === value)
      );
      setCloudSyncText(csIndex.map((value) => value.value));
      // if (csIndex > -1) {
      //     setCloudSyncText(props.formObj.sync_status_list[csIndex]['value']);
      // }
      setCloudSync(csIndex.map((value) => value));
    }

    if (parseInt(props.formObj.send_reminder) > -1) {
      let srIndex = SEND_REMINDER.findIndex(x => parseInt(x.id) === parseInt(props.formObj.send_reminder));
      if (srIndex > -1) {
        setSendReminderText(SEND_REMINDER[srIndex]['value']);
      }
      setSendReminder(props.formObj.send_reminder);
    }

    if (parseInt(props.formObj.over_due_reminder) > -1) {
      let orIndex = OVERDUE_REMINDER.findIndex(x => parseInt(x.id) === parseInt(props.formObj.over_due_reminder));
      if (orIndex > -1) {
        setOverdueReminderText(OVERDUE_REMINDER[orIndex]['value']);
      }
      setOverdueReminder(props.formObj.over_due_reminder);
    }

    if (props.formObj.password) {
      setPasswordText('Yes');
      setIsPassword(1);
      setPassword(props.formObj.password);
    } else {
      setPasswordText('No');
      setIsPassword(0);
    }

    if (props.formObj.reference_id) {
      setReferenceText(props.formObj.reference_id);
      setReferenceId(props.formObj.reference_id);
    }

    if (props.formObj.is_use) {
      setIsEditRecipient(true);
      setIsEditDocument(true);
      setIsEditRequestForm(true);
      setIsAdditionalSetting(true);
    }

  }, [props]);

  function onBack(e) {
    e.preventDefault();
    const formData = { ...props.formObj };
    formData.current_step = 3;
    formData.is_use = false;
    props.setFormObj(formData);
    navigate('/client-portal/sleeve/edit/' + formData.envelope_uuid + '/3');
  }

  const cloudeStoragehandleChange = (selectedValues) => {
    if (selectedValues.length > 0) {
      let index = selectedValues.length - 1;
      if (selectedValues[index].id === 0) {
        setCloudSync([{ id: 0, value: "Disabled" }]);
      } else {
        let idx = selectedValues.findIndex(x => x.id === 0);
        if (idx > -1) {
          selectedValues.splice(idx, 1);
        }
        setCloudSync(selectedValues);
      }
    } else {
      setCloudSync([{ id: 0, value: "Disabled" }]);
    }

  };

  const customStyles = {
    option: (defaultStyles, state) => ({
      ...defaultStyles,
      color: state.isSelected ? "white" : "#fff",
      backgroundColor: "white",
      height: "40px"
    }),
  };

  const Option = (props) => {
    return (
      <div>
        <components.Option {...props}>
          <input
            type="checkbox"
            checked={props.isSelected}
            onChange={() => null}
            style={{ marginTop: "-10px" }}
          />
          <label style={{ marginTop: "3px", marginLeft: 8, position: "absolute" }}>{props.label}</label>
        </components.Option>
      </div>
    );
  };


  async function onSubmitForm(e, type) {
    e.preventDefault();
    let error = false;
    let errorObj = { ...errorsObj };
    let envelopeFormData = { ...props.formObj };
    if (!envelopeSenderId) {
      errorObj.sender_id = "Please select sender";
      error = true;
    }
    if (!envelopeName) {
      errorObj.envelope_name = "Sleeves name must be required";
      error = true;
    }
    if (!envelopeDate) {
      errorObj.envelope_date = "Please select date";
      error = true;
    }
    if (!clientMessage) {
      errorObj.client_message = "Please enter message";
      error = true;
    }
    if (envelopeFormData.recipient_List.length === 0) {
      errorObj.recipient = "Please add recipient";
      error = true;
    }
    if (!subject) {
      errorObj.subject = "Subject must be required";
      error = true;
    }
    if (!emailText) {
      errorObj.email_text = "Email text must be required";
      error = true;
    }
    if (envelopeFormData.documents.length === 0 && envelopeFormData.sign_documents.length === 0)
      if (envelopeFormData.documents.length === 0 && envelopeFormData.fill_forms.length === 0 && envelopeFormData.sign_documents.length === 0) {
        errorObj.documents = "Please create document";
        error = true;
      }

    //Validation of check sign documents fillable or not.
    if (envelopeFormData.sign_documents.length !== 0) {
      let isAllFillable = true;
      for (let i = 0; i < envelopeFormData.sign_documents.length; i++) {
        if (envelopeFormData.sign_documents[i].request_id === null) {
          isAllFillable = false;
          break;
        }
      }
      if (isAllFillable === false) {
        toast.error("Please make fillable sign request.");
        return false;
      }
    }

    /*
    if (envelopeFormData.sign_documents.length !== 0){
        let checkAnyOneFillable = false;
        for (let i = 0; i < envelopeFormData.sign_documents.length; i++) {
            if(envelopeFormData.sign_documents[i].request_id !== ""){
                checkAnyOneFillable = true;
                break;
            }
        }
        if(checkAnyOneFillable === false){
            toast.error("Please make fillable sign request.");
            return false;
        }
    }
    */

    if (parseInt(isPassword) === 1 && !password) {
      errorObj.password = 'Please enter password';
      error = true;
    }

    setErrors(errorObj);

    setTimeout(function () {
      let classList = document.getElementsByClassName('text-danger');
      if (classList.length > 0) {
        let scrollDiv = classList[0].getBoundingClientRect().top + window.scrollY - 200;
        window.scrollTo({ top: scrollDiv, behavior: 'smooth' });
      }
    }, 0);

    if (error) return;

    let recipientIds = "";
    for (let i = 0; i < envelopeFormData.recipient_List.length; i++) {
      recipientIds += envelopeFormData.recipient_List[i]["id"];
      if (envelopeFormData.recipient_List.length !== i + 1) {
        recipientIds += ",";
      }
    }

    const cloudOption = (cloudSync.map((i) => i.id).join(','));

    envelopeFormData.submit_type = type;
    envelopeFormData.sender_id = envelopeSenderId;
    envelopeFormData.envelope_name = Utils.getEnvelopeNameForPayload(envelopeName, envelopeFormData?.is_negotiation);
    delete envelopeFormData.envelope_name_updated;
    envelopeFormData.envelope_date = envelopeDate;
    envelopeFormData.client_message = clientMessage;
    envelopeFormData.subject = subject;
    envelopeFormData.email_text = emailText;
    envelopeFormData.recipient_ids = recipientIds;
    envelopeFormData.name_convention = nameConvention;
    envelopeFormData.cloud_sync = cloudOption;
    envelopeFormData.send_reminder = sendReminder;
    envelopeFormData.over_due_reminder = overdueReminder;
    envelopeFormData.reference_id = referenceId;

    if (parseInt(isPassword) === 1) {
      envelopeFormData.password = password;
    } else {
      envelopeFormData.password = '';
    }

    props.setLoading(true);

    let ipAddress = '';
    await Utils.getIpAddress().then(response => {
      ipAddress = response;
    });

    const { timeZone } = Intl.DateTimeFormat().resolvedOptions();
    envelopeFormData.time_zone = (timeZone) ? timeZone : '';
    // envelopeFormData.ip_address = ipAddress;

    envelopeFinish(envelopeFormData)
      .then((response) => {
        if (type === 1) {
          navigate("/manage/draft");
          toast.success(response.data.message);
        } else {
          envelopeFormData.is_done = true;
          props.setFormObj(envelopeFormData);
          setIsInvited(1);
        }
        props.setLoading(false);
      })
      .catch((err) => {
        props.setLoading(false);
        if (err.response.status === 411) {
          openCheckSMSCreditRef?.current.click();
        } else if (err.response.status === 415) {
          openCloudStorageRef?.current.click();
        } else {
          toast.error(Utils.getErrorMessage(err));
        }
      });
  }

  function onRemoveRecipient(e, index) {
    e.preventDefault();
    const formData = { ...props.formObj };
    formData.recipient_List.splice(index, 1);
    props.setFormObj(formData);
  }

  function onEditRecipient(e, obj) {
    e.preventDefault();
    let formData = { ...recipientData };
    formData.id = obj.id;
    formData.first_name = obj.first_name;
    formData.last_name = obj.last_name;
    formData.email = obj.email;
    formData.mobile = obj.mobile;
    formData.country_id = obj.country_id;
    formData.company_name = obj.company_name;
    formData.address_1 = obj.address_1;
    formData.address_2 = obj.address_2;
    formData.city = obj.city;
    formData.state = obj.state;
    formData.address_country_id = obj.address_country_id;
    formData.zip_code = obj.zip_code;
    setRecipientData(formData);
    buttonRef.current?.click();
  }

  function onAddRecipient() {
    setRecipientData({
      id: 0,
      first_name: "",
      last_name: "",
      email: "",
      mobile: "",
      country_id: 227,
      company_name: "",
      address_1: "",
      address_2: "",
      city: "",
      state: "",
      address_country_id: "",
      zipcode: "",
    });
  }

  function onEnvelopeStart(e) {
    e.preventDefault();
    navigate("/client-portal");
  }

  function onViewEnvelope(e) {
    e.preventDefault();
    const envelopeFormData = { ...props.formObj };
    navigate("/manage/" + envelopeFormData.envelope_uuid);
  }

  function onAddTemplate(e) {
    e.preventDefault();
    const envelopeFormData = { ...props.formObj };
    setDeleteEnvelope({ id: envelopeFormData.envelope_id, name: envelopeFormData.envelope_name });
  }

  const goToHome = (e) => {
    clsAddTemplateRef?.current.click();
    navigate("/client-portal");
  };

  const handlePassword = (e) => {
    setIsPassword(e.target.value);
    setPassword('');
  };

  const handleUseDocFormTemplate = (e, type) => {
    e.preventDefault();

    setFromTemplate(type);
    setIsUseFromTemplate(true);
  };

  const handleEnvInput = (e, type) => {

    let envelopeData = { ...props.formObj };

    if (type === 'name') {
      setEnvelopeName(e.target.value);
      envelopeData.envelope_name = e.target.value;
    } else if (type === 'date') {
      setEnvelopeDate(e);
      envelopeData.envelope_date = e;
    } else if (type === 'message') {
      setClientMessage(e.target.value);
      envelopeData.client_message = e.target.value;
    } else if (type === 'subject') {
      setSubject(e.target.value);
      envelopeData.subject = e.target.value;
    } else if (type === 'email_text') {
      setEmailText(e.target.value);
      envelopeData.email_text = e.target.value;
    } else if (type === 'send_envelope_by') {
      envelopeData.send_envelope_by = e.target.value;
      if (e.target.value === "1") {
        setSmsType(1);
        setSmsAmount(0);
        envelopeData.sms_type = 1;
      }
    } else if (type === 'sms_type') {
      envelopeData.send_envelope_by = 2; // 2 use for selected email and SMS
      let smsTypeList = [...SMS_SENDER_LIST];
      let index = smsTypeList.findIndex(x => parseInt(x.id) === parseInt(e.target.value));
      if (index > -1) {
        setSmsAmount(smsTypeList[index]['amount'] * props.formObj.recipient_List.length);
      }
      envelopeData.sms_type = e.target.value;
    }

    props.setFormObj(envelopeData);
  };

  const showDate = (date) => {
    let dateFormat = '';
    if (date) {
      dateFormat = new Date(date);
    }
    return dateFormat;
  };

  const showDateFormat = (id) => {
    let value = '';
    let index = DATE_FORMAT_LIST.findIndex(x => parseInt(x.id) === parseInt(id));
    if (index > -1) {
      value = DATE_FORMAT_LIST[index]['format'];
    }
    return value;
  };

  const showDatePlaceholder = (id) => {
    let value = '';
    let index = DATE_FORMAT_LIST.findIndex(x => parseInt(x.id) === parseInt(id));
    if (index > -1) {
      value = DATE_FORMAT_LIST[index]['text'];
    }
    return value;
  };

  //SignDocument Functions
  const handleDownload = async (e, obj) => {
    e.preventDefault();
    props.setLoading(true);
    await Utils.downloadAnyFile(obj.path, obj.file_name);
    props.setLoading(false);
  };


  const onRequestSignDocumentDelete = (e, data) => {
    e.preventDefault();
    props.setLoading(true);
    let obj = {
      id: data.id,
    };
    removeEnvelopeSignDocument(obj)
      .then((response) => {
        let envelopeData = { ...props.formObj };
        let index = envelopeData.sign_documents.findIndex((x) => x.id === obj.id);
        envelopeData.sign_documents.splice(index, 1);
        props.setFormObj(envelopeData);
        toast.success(response.data.message);
        props.setLoading(false);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
        props.setLoading(false);
      });
  };


  const onRequestSignDocumentRender = (e, data) => {
    console.log("Render make fillable form");
    e.preventDefault();

    const keysToRemove = ["mousePosition", "pagesPosition", "placeholders"];
    keysToRemove.forEach(key => localStorage.removeItem(key));

    props.setLoading(true);
    setSignatureDocumentData(data);
    setMakeFillable(true);
    btnSignDocumentPopup.current?.click();

  };


  const handleMakeFillable = () => {
    let current = (makeFillable === false) ? true : false;
    setMakeFillable(current);
  }


  useEffect(() => {
    const makeFillableAsync = async () => {
      if (directMakeFillableOpen === true) {
        const keysToRemove = ["mousePosition", "pagesPosition", "placeholders"];
        keysToRemove.forEach(key => localStorage.removeItem(key));
        await setMakeFillable(true);
        btnSignDocumentPopup.current?.click();
        setDirectMakeFillableOpen(false);
      }
    };

    makeFillableAsync(); // Call the async function
  }, [directMakeFillableOpen]);

  // Helper to get initials from name
  function getInitials(firstName, lastName) {
    if (!firstName && !lastName) return '';
    return ((firstName ? firstName[0] : '') + (lastName ? lastName[0] : '')).toUpperCase();
  }


  // Prepare sender options for react-select
  const senderOptions = senderList.map(item => ({
    value: Number(item.id),
    label: `${item.first_name} ${item.last_name} (${item.email})`,
    data: item,
  }));
  const selectedSenderOption = senderOptions.find(opt => opt.value === Number(envelopeSenderId)) || null;


  return (
    <>
      {isInvited === 1 &&
        <div className="sleeve-gradient-bg sleeve-step">
          <div className="sleeve-main-card">
            <div className="sleeve-success-card">
              <img src="/images/paper-plane.webp" alt="Success" className="sleeve-success-img" />

              <h3 className="sleeve-success-title">Contract Sent Successfully!</h3>
              <p className="sleeve-success-message">
                Your contract has been sent to all recipients. We will notify you via email when there is any activity on this contract.
              </p>

              <div className="sleeve-success-actions">
                <button
                  className="sleeve-btn-success-secondary"
                  onClick={onViewEnvelope}
                >
                  <i className="bi bi-eye"></i> View Contract
                </button>

                <button
                  className="sleeve-btn-success-primary"
                  onClick={onEnvelopeStart}
                >
                  <i className="bi bi-plus-circle"></i> Create Another
                </button>
              </div>
            </div>
          </div>
        </div>
      }
      {isInvited === 0 &&
        <div className="sleeve-gradient-bg sleeve-step">
          <div className="sleeve-main-card">
            {/* Header */}
            <div className="sleeve-contract-setup-header">
              <div className="sleeve-contract-setup-header-content">
                <div>
                  <div className="sleeve-contract-title">Review & Send</div>
                  <div className="sleeve-contract-subtitle">Review all details and send your contract.</div>
                </div>
                <div className="text-end">
                  {!props.formObj?.is_negotiation && <div className="sleeve-step-indicator-custom">Step 4 of 4</div>}
                </div>
              </div>
            </div>

            {/* Send Contract By */}
            <div className="sleeve-sender-card">
              <h2 className="sleeve-heading mb-3">
                <i className="bi bi-send me-2"></i>
                Send Contract By
              </h2>
              <div className="row g-3">
                <div className="col-lg-6">
                  <div className={`card h-100 border ${sendEnvelopeBy === 1 ? 'border-primary bg-light' : ''}`} style={{ cursor: 'pointer' }} onClick={() => handleEnvInput({ target: { value: 1 } }, 'send_envelope_by')}>
                    <div className="card-body">
                      <div className="form-check">
                        <input className="form-check-input" type="radio" name="radio-card" id="radio-card-1" value={1}
                          checked={sendEnvelopeBy === 1}
                          onChange={(e) => handleEnvInput(e, 'send_envelope_by')} />
                        <label className="form-check-label fw-bold d-block" htmlFor="radio-card-1">
                          Email Only <span className="badge bg-secondary float-end">1 Sleeves Credit</span>
                        </label>
                        <p className="text-muted small mt-2 mb-0">The collaborator will receive an email containing a secure link to review, sign, and complete the contract.</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className={`card h-100 border ${sendEnvelopeBy === 2 ? 'border-primary bg-light' : ''}`} style={{ cursor: 'pointer' }} onClick={() => handleEnvInput({ target: { value: 2 } }, 'send_envelope_by')}>
                    <div className="card-body">
                      <div className="form-check">
                        <input className="form-check-input" type="radio" name="radio-card" id="radio-card-2" value={2}
                          checked={sendEnvelopeBy === 2}
                          onChange={(e) => handleEnvInput(e, 'send_envelope_by')} />
                        <label className="form-check-label fw-bold d-block" htmlFor="radio-card-2">
                          Email and SMS
                          <span className="badge bg-secondary float-end">1 Sleeves Credit + {Math.round(smsAmount / PER_SMS_AMOUNT)} SMS</span>
                        </label>
                        <p className="text-muted small mt-2">The collaborator will receive both an email and an SMS.</p>

                        <div className="mt-2" onClick={(e) => e.stopPropagation()}>
                          <label className="form-label small text-muted">SMS Types</label>
                          <select className="form-select form-select-sm"
                            value={smsType} onChange={(e) => handleEnvInput(e, 'sms_type')}>
                            {SMS_SENDER_LIST.map((item, index) =>
                              <option key={index} value={item.id}>{item.value}</option>
                            )}
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Sender */}
            <div className="sleeve-sender-card">
              <h2 className="sleeve-heading mb-3">
                <i className="bi bi-person me-2"></i>
                Your Email Address (Sender)
                <i className="bi bi-info-circle ms-1 text-muted cursor-pointer fs-6" data-toggle="tooltip" title="The selected email address will be used to execute the contract signature." />
              </h2>
              <ReactSelect
                classNamePrefix="sleeve-sender-select"
                value={selectedSenderOption}
                onChange={option => setEnvelopeSenderId(option ? Number(option.value) : 0)}
                options={senderOptions}
                placeholder="Select sender"
                isSearchable
                formatOptionLabel={option => (
                  <div className="sleeve-sender-option">
                    <div className="sleeve-sender-initials">
                      {getInitials(option.data.first_name, option.data.last_name)}
                    </div>
                    <div>
                      <div className="sleeve-sender-name">{option.data.first_name} {option.data.last_name}</div>
                      <div className="sleeve-sender-email">{option.data.email}</div>
                    </div>
                  </div>
                )}
                isDisabled={props.formObj?.is_negotiation === true}
              />
              {errors.sender_id && <div className="text-danger small mt-1">{errors.sender_id}</div>}
            </div>

            {/* Contract Detail */}
            <div className="sleeve-sender-card">
              <h2 className="sleeve-heading mb-3">
                <i className="bi bi-file-earmark-text me-2"></i>
                Contract Detail
              </h2>
              <div className="row g-3">
                <div className="col-md-6">
                  <label className="sleeve-step-label">Contract Name</label>
                  <input type="text" className="sleeve-step-input"
                    onChange={(e) => handleEnvInput(e, 'name')}
                    value={envelopeName}
                    placeholder="Enter Contract Name"
                    readOnly={props.formObj?.is_negotiation === true}
                    style={{
                      backgroundColor: props.formObj?.is_negotiation ? "#f7f7f7" : "white",
                      cursor: props.formObj?.is_negotiation ? "not-allowed" : "text",
                    }} />
                  {errors.envelope_name && <div className="text-danger small mt-1">{errors.envelope_name}</div>}
                </div>
                <div className="col-md-6">
                  <CustomDatePicker
                    label="Due Date"
                    ref={dueDateRef}
                    selected={showDate(envelopeDate)}
                    onChange={(date) => handleEnvInput(date, 'date')}
                    minDate={pastDate}
                    dateFormat={showDateFormat(1)}
                    placeholder={showDatePlaceholder(1)}
                    className="sleeve-step-input"
                    error={errors.envelope_date}
                    readOnly={props.formObj?.is_negotiation === true}
                  />
                </div>
                <div className="col-12">
                  <label className="sleeve-step-label">Client Portal Message</label>
                  <textarea className="sleeve-step-textarea" rows={4}
                    placeholder="Enter Message to Client"
                    onChange={(e) => handleEnvInput(e, 'message')}
                    value={clientMessage} />
                  {errors.client_message && <div className="text-danger small mt-1">{errors.client_message}</div>}
                </div>
              </div>
            </div>

            {/* Collaborator Details */}
            <div className="sleeve-sender-card">
              <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
                <h2 className="sleeve-heading mb-0">
                  <i className="bi bi-people me-2"></i>
                  Collaborator Details
                </h2>
                <div className="d-flex gap-2 flex-wrap">
                  {isEditRecipient && (
                    <>
                      <button type="button" className="btn btn-outline-secondary btn-sm" style={{ fontSize: "14px" }}
                        data-bs-toggle="offcanvas" data-bs-target="#SearchRecipients">
                        <i className="bi bi-search me-1" /> Search
                      </button>
                      <button className="d-none" ref={buttonRef} data-bs-toggle="offcanvas" data-bs-target="#addRecipients"></button>
                      <button type="button" className="step2-add-btn"
                        data-bs-toggle="offcanvas" data-bs-target="#addRecipients" onClick={onAddRecipient}>
                        <i className="bi bi-plus me-2" /> Add Collaborator
                      </button>
                    </>
                  )}
                  {!isEditRecipient && !props.formObj?.is_negotiation && (
                    <button className="btn btn-link text-primary p-0 text-decoration-none" onClick={() => setIsEditRecipient(true)}>
                      <i className="bi bi-pencil-fill me-1" /> Edit
                    </button>
                  )}
                </div>
              </div>

              <div className="d-flex flex-column gap-2">
                {props.formObj.recipient_List.map((item, index) => (
                  <div className="recipient-list-item-custom" key={index}>
                    <div className="recipient-list-info">
                      <div className="recipient-info-user">
                        <div className="avatar-circle-custom">
                          {getInitials(item.first_name, item.last_name)}
                        </div>
                        <div className="recipient-name fw-bold">{item.first_name} {item.last_name}</div>
                      </div>
                      <div className="recipient-email-mobile">
                        <span><i className="bi bi-envelope me-1"></i>{item.email}</span>
                        {item.mobile && <span><i className="bi bi-phone me-1"></i>{Utils.mobileFormat(item)}</span>}
                      </div>
                    </div>
                    {isEditRecipient && (
                      <div className="recipient-list-actions">
                        <i className="bi bi-pencil-fill text-primary cursor-pointer" onClick={(e) => onEditRecipient(e, item)} title="Edit" />
                        <i className="bi bi-x-circle text-danger cursor-pointer" onClick={(e) => onRemoveRecipient(e, index)} title="Remove" />
                      </div>
                    )}
                  </div>
                ))}
                {errors.recipient && <div className="text-danger small">{errors.recipient}</div>}
              </div>
            </div>

            {/* Email Details */}
            <div className="sleeve-sender-card">
              <h2 className="sleeve-heading mb-3">
                <i className="bi bi-envelope-at me-2"></i>
                Email Details
              </h2>
              <div className="row g-3">
                <div className="col-12">
                  <label className="sleeve-step-label">Subject</label>
                  <input type="text" className="sleeve-step-input"
                    value={subject}
                    onChange={(e) => handleEnvInput(e, 'subject')}
                    placeholder="Enter Email Subject" />
                  {errors.subject && <div className="text-danger small mt-1">{errors.subject}</div>}
                </div>
                <div className="col-12">
                  <label className="sleeve-step-label">Email Text</label>
                  <textarea className="sleeve-step-textarea" rows={6} value={emailText}
                    onChange={(e) => handleEnvInput(e, 'email_text')}
                    placeholder="Enter Email text box" />
                  {errors.email_text && <div className="text-danger small mt-1">{errors.email_text}</div>}
                </div>
              </div>
            </div>

            {/* Sign Documents */}
            {props.formObj.sign_documents.length > 0 && (
              <div className="sleeve-sender-card">
                <div className="d-flex justify-content-between align-items-center mb-3 gap-2">
                  <h2 className="sleeve-heading mb-0">
                    <i className="bi bi-pencil-square me-2"></i>
                    Contract Request
                  </h2>
                  {!isEditSignDocumentForm && (
                    <button className="btn btn-link text-primary p-0 text-decoration-none" onClick={() => setIsEditSignDocumentForm(true)}>
                      <i className="bi bi-pencil-fill me-1" /> Edit
                    </button>
                  )}
                </div>
                <div className="d-flex flex-column gap-2">
                  {props.formObj.sign_documents.map((item, index) => (
                    <div key={index} className="p-3 border rounded bg-light d-flex justify-content-between align-items-center flex-wrap gap-2">
                      <div className="fw-bold text-dark">
                        {Utils.getCleanEnvelopeName(item.name, props.formObj?.is_negotiation)}
                      </div>
                      <div className="d-flex align-items-center gap-3 flex-wrap">
                        {parseInt(item.request_id) === 0 ? (
                          <span className="badge bg-secondary" title="Everyone">Everyone</span>
                        ) : (
                          <div className="d-flex gap-1">
                            {item.request_display.map((recipient, i) =>
                              <span key={i} className="sleeve-badge-custom" title={recipient.full_name}>{recipient.display}</span>
                            )}
                          </div>
                        )}

                        {isEditSignDocumentForm && (
                          <div className="d-flex gap-2 flex-wrap">
                            <span className="d-none" ref={btnSignDocumentPopup} data-bs-toggle="offcanvas" data-bs-target="#makeFillableForm" ></span>
                            <button className="sleeve-btn-edit-form" onClick={(e) => onRequestSignDocumentRender(e, item)}>
                              <i className="bi bi-pencil-square"></i>
                              {item.request_id === "" ? "Make Fillable" : "Edit Form"}
                            </button>
                            <button className="sleeve-btn-icon-action" onClick={(e) => handleDownload(e, item)} title="Download">
                              <i className="bi bi-download"></i>
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                  ))}
                  {errors.sign_documents && <div className="text-danger small">{errors.sign_documents}</div>}
                </div>
              </div>
            )}

            {/* Additional Settings */}
            <div className="sleeve-sender-card">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h2 className="sleeve-heading mb-0">
                  <i className="bi bi-gear me-2"></i>
                  Additional Settings
                </h2>
                {!isAdditionalSetting && (
                  <button className="btn btn-link text-primary p-0 text-decoration-none" onClick={() => setIsAdditionalSetting(true)}>
                    <i className="bi bi-pencil-fill me-1" /> Edit
                  </button>
                )}
              </div>

              {!isAdditionalSetting ? (
                <div className="small text-muted">
                  <div className="row mb-2">
                    <div className="col-4 fw-bold">Naming Convention:</div>
                    <div className="col-8">{nameConventionText}</div>
                  </div>
                  <div className="row mb-2">
                    <div className="col-4 fw-bold">Cloud Storage Sync:</div>
                    <div className="col-8">{cloudSyncText.join(", ") || "Disabled"}</div>
                  </div>
                  <div className="row mb-2">
                    <div className="col-4 fw-bold">Send Reminder:</div>
                    <div className="col-8">{sendReminderText}</div>
                  </div>
                  <div className="row mb-2">
                    <div className="col-4 fw-bold">Overdue Reminder:</div>
                    <div className="col-8">{overdueReminderText}</div>
                  </div>
                  <div className="row mb-2">
                    <div className="col-4 fw-bold">Password Protected:</div>
                    <div className="col-8">{passwordText}</div>
                  </div>
                  <div className="row mb-2">
                    <div className="col-4 fw-bold">Reference ID:</div>
                    <div className="col-8">{referenceText}</div>
                  </div>
                </div>
              ) : (
                <div className="row g-3">
                  <div className="col-12">
                    <label className="sleeve-step-label">Naming Convention</label>
                    <select className="form-select" value={nameConvention} onChange={(e) => setNameConvention(e.target.value)}>
                      {NAME_CONVENTION.map((item, index) => <option key={index} value={item.id}>{item.value}</option>)}
                    </select>
                  </div>
                  <div className="col-12">
                    <label className="sleeve-step-label">Cloud Storage Sync</label>
                    <ReactSelect
                      value={cloudSync}
                      isMulti
                      closeMenuOnSelect={false}
                      hideSelectedOptions={false}
                      onChange={cloudeStoragehandleChange}
                      options={syncStatusList}
                      getOptionLabel={options => options['value']}
                      components={{ Option }}
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="sleeve-step-label">Send Reminder</label>
                    <select className="form-select" value={sendReminder} onChange={(e) => setSendReminder(e.target.value)}>
                      {SEND_REMINDER.map((item, index) => <option key={index} value={item.id}>{item.value}</option>)}
                    </select>
                  </div>
                  <div className="col-md-6">
                    <label className="sleeve-step-label">Overdue Reminder</label>
                    <select className="form-select" value={overdueReminder} onChange={(e) => setOverdueReminder(e.target.value)}>
                      {OVERDUE_REMINDER.map((item, index) => <option key={index} value={item.id}>{item.value}</option>)}
                    </select>
                  </div>
                  <div className="col-12">
                    <label className="sleeve-step-label">Password Protected</label>
                    <div className="input-group">
                      <select className="form-select" style={{ maxWidth: '100px' }} value={isPassword} onChange={handlePassword}>
                        {PASSWORD_LIST.map((item, index) => <option key={index} value={item.id}>{item.value}</option>)}
                      </select>
                      {isPassword > 0 && (
                        <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="form-control" placeholder="Enter password" />
                      )}
                    </div>
                    {errors.password && <div className="text-danger small mt-1">{errors.password}</div>}
                  </div>
                  <div className="col-12">
                    <label className="sleeve-step-label">Reference ID</label>
                    <input type="text" value={referenceId} onChange={(e) => setReferenceId(e.target.value)} className="form-control" />
                  </div>
                </div>
              )}
            </div>

            {/* Buttons */}
            <div className="sleeve-step-buttons mt-4">
              <button type="button" onClick={onBack} className="sleeve-btn-back">Back</button>
              <div className="sleeve-step-buttons-right">
                <button type="button" onClick={(e) => onSubmitForm(e, 1)} className="sleeve-btn-save">Save & Exit</button>
                <button type="button" onClick={(e) => onSubmitForm(e, 2)} className="sleeve-btn-next">Send</button>
              </div>
            </div>

          </div>
        </div>
      }

      <EnvelopeRecipients formObj={props.formObj} setFormObj={props.setFormObj}
        setLoading={props.setLoading} recipData={recipientData}
        setDocData={setRecipientData} />

      <SearchRecipient formObj={props.formObj} setFormObj={props.setFormObj} />

      <MakeFillablePopup formObj={props.formObj} signatureDocumentData={signatureDocumentData} setFormObj={props.setFormObj} setLoading={props.setLoading} makeFillable={makeFillable} handleMakeFillable={handleMakeFillable}></MakeFillablePopup>

      <button type="button" ref={addTemplateRef} data-bs-toggle="modal" className="d-none"
        data-bs-target="#addToTemplateModal" />
      <div className="modal fade" id="addToTemplateModal" tabIndex="-1" aria-labelledby="addToTemplateModalLabel"
        aria-hidden="true">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="addToTemplateModalLabel">Added in Templates.</h5>
              <button type="button" className="btn btn-close close_btn text-reset mb-2"
                ref={clsAddTemplateRef} data-bs-dismiss="modal" aria-label="Close">
                <i className="bi bi-x-circle" aria-hidden="true" />
              </button>
            </div>
            <div className="modal-body">
              <p className="py-2 mb-0">You have Successfully added this Sleeves in Templates.</p>
            </div>
            <div className="modal-footer ">
              <button type="button" onClick={goToHome} className="btn btn-primary">Go to Home</button>
            </div>
          </div>
        </div>
      </div>

      <span data-bs-toggle="modal" data-bs-target="#openCheckSMSCredit" ref={openCheckSMSCreditRef} />
      <div className="modal fade" id="openCheckSMSCredit" tabIndex={-1}
        aria-labelledby="openCheckSMSCreditLabel" aria-hidden="true">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-body">
              <p className="py-2">You don't have enough SMS credit, click on Billing to purchase extra SMS
                Credits.</p>
            </div>
            <div className="modal-footer ">
              <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>

      <span data-bs-toggle="modal" data-bs-target="#openCloudStorage" ref={openCloudStorageRef} />
      <div className="modal fade" id="openCloudStorage" tabIndex={-1}
        aria-labelledby="openCloudStorageLabel" aria-hidden="true">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-body">
              <p className="py-2">Now, cloud storage not connected. Please connect the cloud storage.</p>
            </div>
            <div className="modal-footer ">
              <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default EnvelopeStep4;
